import { render, staticRenderFns } from "./PwdLessOtpDelivery.vue?vue&type=template&id=4f6ae3b5&scoped=true"
import script from "./PwdLessOtpDelivery.vue?vue&type=script&lang=js"
export * from "./PwdLessOtpDelivery.vue?vue&type=script&lang=js"
import style0 from "./PwdLessOtpDelivery.vue?vue&type=style&index=0&id=4f6ae3b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6ae3b5",
  null
  
)

export default component.exports